import { Invoice } from '@accounting/interfaces/invoice';
import Vue from 'vue';

import { Component, Prop } from 'vue-property-decorator';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import { faBook } from '@fortawesome/free-solid-svg-icons';
import ModulesHelper from '@core/services/modules.helper';

library.add(faPlus);
library.add(faIdCard);
library.add(faBook);

@Component({
  name: 'bpc-credit-note-tabs',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
  },
})
export default class CreditNoteTabs extends Vue {
  public mounted() {
    this.$store.dispatch('invoiceCounts/getCreditNotesCount');
  }
  get creditNotesInDraft() {
    return this.$store.getters['invoiceCounts/creditNotesInDraft'];
  }
  get creditNotesInToPay() {
    return this.$store.getters['invoiceCounts/creditNotesInTopay'];
  }
  get accountingIntegrationsModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(
      ModulesHelper.ACCOUNTING_INTEGRATIONS_MODULE_NAME,
    );
  }
}
